import { db } from './firebase';
import { collection, query, where, getDocs, updateDoc, deleteDoc, doc, setDoc, serverTimestamp, Timestamp } from 'firebase/firestore';

export const ADMIN_UID = "fFZpL19OTaMWKL2jO5m47fjzHTR2";
export const MAX_EVENTOS_GRATIS = 2;

export const LISTAS_LIBROS = {
  Tendencias: [
    { titulo: "La asistenta", autor: "Freida McFadden" },
    { titulo: "Hábitos atómicos", autor: "James Clear" },
    { titulo: "Asesinato en el Molino del Cura", autor: "Arantza Portabales" },
    { titulo: "Las hijas de la criada", autor: "Sonsoles Ónega" },
    { titulo: "Todo muere", autor: "Juan Gómez-Jurado" },
    { titulo: "El infinito en un junco", autor: "Irene Vallejo" },
    { titulo: "La paciente silenciosa", autor: "Alex Michaelides" },
    { titulo: "Reina roja", autor: "Juan Gómez-Jurado" },
    { titulo: "Lecciones de química", autor: "Bonnie Garmus" },
    { titulo: "El prisionero del cielo", autor: "Carlos Ruiz Zafón" },
    { titulo: "La sombra del viento", autor: "Carlos Ruiz Zafón" },
    { titulo: "El nombre del viento", autor: "Patrick Rothfuss" },
    { titulo: "Circe", autor: "Madeline Miller" },
    { titulo: "Una educación", autor: "Tara Westover" },
    { titulo: "Sapiens", autor: "Yuval Noah Harari" },
    { titulo: "Dune", autor: "Frank Herbert" },
    { titulo: "1984", autor: "George Orwell" },
    { titulo: "El alquimista", autor: "Paulo Coelho" },
    { titulo: "La ladrona de libros", autor: "Markus Zusak" },
    { titulo: "Cien años de soledad", autor: "Gabriel García Márquez" },
  ],
  Ficción: [
    { titulo: "Cien años de soledad", autor: "Gabriel García Márquez" },
    { titulo: "1984", autor: "George Orwell" },
    { titulo: "El gran Gatsby", autor: "F. Scott Fitzgerald" },
    { titulo: "La sombra del viento", autor: "Carlos Ruiz Zafón" },
    { titulo: "El nombre de la rosa", autor: "Umberto Eco" },
    { titulo: "Crimen y castigo", autor: "Fiódor Dostoyevski" },
    { titulo: "El alquimista", autor: "Paulo Coelho" },
    { titulo: "El maestro y Margarita", autor: "Mijaíl Bulgákov" },
    { titulo: "La insoportable levedad del ser", autor: "Milan Kundera" },
    { titulo: "Fahrenheit 451", autor: "Ray Bradbury" },
    { titulo: "Ensayo sobre la ceguera", autor: "José Saramago" },
    { titulo: "El túnel", autor: "Ernesto Sabato" },
  ],
  Misterio: [
    { titulo: "La paciente silenciosa", autor: "Alex Michaelides" },
    { titulo: "Reina roja", autor: "Juan Gómez-Jurado" },
    { titulo: "La chica del tren", autor: "Paula Hawkins" },
    { titulo: "Asesinato en el Orient Express", autor: "Agatha Christie" },
    { titulo: "El código Da Vinci", autor: "Dan Brown" },
    { titulo: "Estudio en escarlata", autor: "Arthur Conan Doyle" },
    { titulo: "Pequeñas mentiras", autor: "Liane Moriarty" },
    { titulo: "Muerte en el Nilo", autor: "Agatha Christie" },
    { titulo: "La verdad sobre el caso Harry Quebert", autor: "Joël Dicker" },
    { titulo: "Perdida", autor: "Gillian Flynn" },
    { titulo: "El juego de Ripper", autor: "Isabel Allende" },
    { titulo: "La ladrona de libros", autor: "Markus Zusak" },
  ],
  "Ciencia ficción": [
    { titulo: "Dune", autor: "Frank Herbert" },
    { titulo: "Fundación", autor: "Isaac Asimov" },
    { titulo: "El juego de Ender", autor: "Orson Scott Card" },
    { titulo: "Neuromante", autor: "William Gibson" },
    { titulo: "Solaris", autor: "Stanisław Lem" },
    { titulo: "La guerra de los mundos", autor: "H.G. Wells" },
    { titulo: "El cuento de la criada", autor: "Margaret Atwood" },
    { titulo: "Ready Player One", autor: "Ernest Cline" },
    { titulo: "La máquina del tiempo", autor: "H.G. Wells" },
    { titulo: "Tropas del espacio", autor: "Robert A. Heinlein" },
    { titulo: "Hyperion", autor: "Dan Simmons" },
    { titulo: "El fin de la eternidad", autor: "Isaac Asimov" },
  ],
  Fantasía: [
    { titulo: "La comunidad del anillo", autor: "J.R.R. Tolkien" },
    { titulo: "Harry Potter y la piedra filosofal", autor: "J.K. Rowling" },
    { titulo: "Juego de tronos", autor: "George R.R. Martin" },
    { titulo: "El nombre del viento", autor: "Patrick Rothfuss" },
    { titulo: "Alas de sangre", autor: "Rebecca Yarros" },
    { titulo: "El camino de los reyes", autor: "Brandon Sanderson" },
    { titulo: "Circe", autor: "Madeline Miller" },
    { titulo: "La brújula dorada", autor: "Philip Pullman" },
    { titulo: "Eragon", autor: "Christopher Paolini" },
    { titulo: "El hobbit", autor: "J.R.R. Tolkien" },
    { titulo: "El Imperio Final", autor: "Brandon Sanderson" },
    { titulo: "El mago de Terramar", autor: "Ursula K. Le Guin" },
  ],
  Romance: [
    { titulo: "Orgullo y Prejuicio", autor: "Jane Austen" },
    { titulo: "Alas de sangre", autor: "Rebecca Yarros" },
    { titulo: "Yo antes de ti", autor: "Jojo Moyes" },
    { titulo: "El tiempo entre costuras", autor: "María Dueñas" },
    { titulo: "Outlander", autor: "Diana Gabaldon" },
    { titulo: "La decisión", autor: "Nicholas Sparks" },
    { titulo: "Persuasión", autor: "Jane Austen" },
    { titulo: "El diario de Bridget Jones", autor: "Helen Fielding" },
    { titulo: "Nunca jamás", autor: "Colleen Hoover" },
    { titulo: "Romper el círculo", autor: "Colleen Hoover" },
    { titulo: "El juego del odio", autor: "Sally Thorne" },
    { titulo: "Lo que el verano dejó", autor: "Emily Henry" },
  ],
  "No ficción": [
    { titulo: "Sapiens", autor: "Yuval Noah Harari" },
    { titulo: "Hábitos atómicos", autor: "James Clear" },
    { titulo: "El infinito en un junco", autor: "Irene Vallejo" },
    { titulo: "Una educación", autor: "Tara Westover" },
    { titulo: "En el camino", autor: "Jack Kerouac" },
    { titulo: "Factfulness", autor: "Hans Rosling" },
    { titulo: "El poder del ahora", autor: "Eckhart Tolle" },
    { titulo: "Pensar rápido, pensar despacio", autor: "Daniel Kahneman" },
    { titulo: "Fueras de serie", autor: "Malcolm Gladwell" },
    { titulo: "Ikigai", autor: "Héctor García" },
    { titulo: "El libro negro del emprendedor", autor: "Fernando Trías de Bes" },
    { titulo: "La actitud del éxito", autor: "Carol Dweck" },
  ],
  Terror: [
    { titulo: "It", autor: "Stephen King" },
    { titulo: "Drácula", autor: "Bram Stoker" },
    { titulo: "El resplandor", autor: "Stephen King" },
    { titulo: "Frankenstein", autor: "Mary Shelley" },
    { titulo: "La llamada de Cthulhu", autor: "H.P. Lovecraft" },
    { titulo: "El exorcista", autor: "William Peter Blatty" },
    { titulo: "Misery", autor: "Stephen King" },
    { titulo: "El silencio de los corderos", autor: "Thomas Harris" },
    { titulo: "México gótico", autor: "Silvia Moreno-Garcia" },
    { titulo: "La maldición de Hill House", autor: "Shirley Jackson" },
    { titulo: "Cementerio de animales", autor: "Stephen King" },
    { titulo: "La casa de hojas", autor: "Mark Z. Danielewski" },
  ],
  Histórica: [
    { titulo: "Los pilares de la Tierra", autor: "Ken Follett" },
    { titulo: "El médico", autor: "Noah Gordon" },
    { titulo: "La catedral del mar", autor: "Ildefonso Falcones" },
    { titulo: "El nombre de la rosa", autor: "Umberto Eco" },
    { titulo: "Memorias de Adriano", autor: "Marguerite Yourcenar" },
    { titulo: "El último catón", autor: "Matilde Asensi" },
    { titulo: "Colón llega tarde", autor: "Antonio Cavanillas de Blas" },
    { titulo: "El capitán Alatriste", autor: "Arturo Pérez-Reverte" },
    { titulo: "La reina descalza", autor: "Ildefonso Falcones" },
    { titulo: "Centennial", autor: "James Michener" },
    { titulo: "El tiempo entre costuras", autor: "María Dueñas" },
    { titulo: "Las rosas de piedra", autor: "Julio Llamazares" },
  ],
  Ensayo: [
    { titulo: "El infinito en un junco", autor: "Irene Vallejo" },
    { titulo: "La sociedad del cansancio", autor: "Byung-Chul Han" },
    { titulo: "Sapiens", autor: "Yuval Noah Harari" },
    { titulo: "Homo Deus", autor: "Yuval Noah Harari" },
    { titulo: "El mundo de ayer", autor: "Stefan Zweig" },
    { titulo: "Una habitación propia", autor: "Virginia Woolf" },
    { titulo: "Sobre la escritura", autor: "Stephen King" },
    { titulo: "El arte de la guerra", autor: "Sun Tzu" },
    { titulo: "Meditaciones", autor: "Marco Aurelio" },
    { titulo: "El origen de las especies", autor: "Charles Darwin" },
    { titulo: "La estructura de las revoluciones científicas", autor: "Thomas Kuhn" },
    { titulo: "El malestar en la cultura", autor: "Sigmund Freud" },
  ],
  Drama: [
    { titulo: "Tan poca vida", autor: "Hanya Yanagihara" },
    { titulo: "La ridícula idea de no volver a verte", autor: "Rosa Montero" },
    { titulo: "Una muerte muy dulce", autor: "Simone de Beauvoir" },
    { titulo: "Los Buddenbrook", autor: "Thomas Mann" },
    { titulo: "La campana de cristal", autor: "Sylvia Plath" },
    { titulo: "El dolor", autor: "Marguerite Duras" },
    { titulo: "El año del pensamiento mágico", autor: "Joan Didion" },
    { titulo: "El corazón es un cazador solitario", autor: "Carson McCullers" },
    { titulo: "Stoner", autor: "John Williams" },
    { titulo: "El cuarteto de Alejandría", autor: "Lawrence Durrell" },
    { titulo: "Middlemarch", autor: "George Eliot" },
    { titulo: "El luto", autor: "C.S. Lewis" },
  ],
};

export const CATEGORIAS_VISUALES = [
  { id: "01", nombre: "Ficción", img: "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=400&q=80" },
  { id: "02", nombre: "Misterio", img: "https://images.unsplash.com/photo-1477332552946-cfb384aeaf1c?auto=format&fit=crop&w=400&q=80" },
  { id: "03", nombre: "Ciencia ficción", img: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=400&q=80" },
  { id: "04", nombre: "Fantasía", img: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=400&q=80" },
  { id: "05", nombre: "Romance", img: "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?auto=format&fit=crop&w=400&q=80" },
  { id: "06", nombre: "No ficción", img: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&w=400&q=80" },
  { id: "07", nombre: "Terror", img: "https://images.unsplash.com/photo-1509248961158-e54f6934749c?auto=format&fit=crop&w=400&q=80" },
  { id: "08", nombre: "Histórica", img: "https://images.unsplash.com/photo-1461360370896-922624d12aa1?auto=format&fit=crop&w=400&q=80" },
  { id: "09", nombre: "Ensayo", img: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&w=400&q=80" },
  { id: "10", nombre: "Drama", img: "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?auto=format&fit=crop&w=400&q=80" },
];

export const GENEROS_LIBROS = ["Aventura", "Biografía", "Ciencia Ficción", "Fantasía", "Histórica", "Misterio", "Romance", "Terror", "Thriller", "Ensayo"];
export const MESES_ES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
export const ESTADOS_LECTURA = [
  { valor: 'quiero_leer', etiqueta: 'Quiero leer', emoji: '🔖', color: '#888' },
  { valor: 'leyendo', etiqueta: 'Leyendo', emoji: '📖', color: '#1DB954' },
  { valor: 'leido', etiqueta: 'Leído', emoji: '✅', color: '#FFD700' },
  { valor: 'dnf', etiqueta: 'Lo dejé', emoji: '🚫', color: '#f44336' },
];

export const UNA_SEMANA_MS = 7 * 24 * 60 * 60 * 1000;
export const TREINTA_DIAS_MS = 30 * 24 * 60 * 60 * 1000;
export const MAX_ACTIVIDAD = 10;

export const generarIdLibro = (titulo, autor) => {
  const id = (titulo + '_' + autor).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '').slice(0, 60);
  return id || `libro_${Date.now()}`;
};

export const normalizarTexto = (texto) =>
  (texto || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

export const mantenerSalas = async () => {
  try {
    const ahora = Date.now();
    const hace1semana = Timestamp.fromMillis(ahora - UNA_SEMANA_MS);
    const hace30dias = Timestamp.fromMillis(ahora - TREINTA_DIAS_MS);
    const snapOcultar = await getDocs(query(collection(db, "salas_info"), where("ultimaActividad", "<", hace1semana), where("activa", "==", true)));
    for (const d of snapOcultar.docs) await updateDoc(d.ref, { activa: false });
    const snapBorrar = await getDocs(query(collection(db, "salas_info"), where("ultimaActividad", "<", hace30dias)));
    for (const d of snapBorrar.docs) {
      const msgs = await getDocs(collection(db, "salas", d.id, "mensajes"));
      for (const m of msgs.docs) await deleteDoc(m.ref);
      const miembros = await getDocs(collection(db, "salas", d.id, "miembros"));
      for (const m of miembros.docs) await deleteDoc(m.ref);
      await deleteDoc(doc(db, "salas", d.id)).catch(() => {}); // borrar doc padre
      await deleteDoc(d.ref);
    }
  } catch (e) { console.error("Error en mantenerSalas:", e); }
};

export const registrarActividad = async (userId, libro) => {
  if (!userId || !libro?.id) return;
  try {
    await setDoc(doc(db, "actividad_reciente", `${userId}_${libro.id}`), {
      userId, libroId: libro.id, titulo: libro.titulo || '', autor: libro.autor || '', portada: libro.portada || '', fecha: serverTimestamp()
    }, { merge: true });
  } catch (e) { console.error("Error registrando actividad:", e); }
};
